export default __webpack_public_path__ + "static/media/phase3_cover.64f90f53.jpg";